// extracted by mini-css-extract-plugin
export default {"productDescription":"D_-z","featuredDescription":"E_-z","description":"F_-z","more":"G_-z","descriptionSku":"H_-z"};